import React from 'react';
import { Select, MenuItem } from '@ui/components';
import { useReport } from './UsageReportContext';
import { intervals } from './utils';

export const TimeSpanSelect = () => {
  const { chart, timeSpan, setTimeSpan } = useReport();
  const onChange = (e: React.ChangeEvent<{ value: unknown }>) =>
    setTimeSpan(Number(e.target.value));

  return (
    <Select value={timeSpan} onChange={onChange} variant='outlined' disabled={!chart}>
      {intervals.map((i) => (
        <MenuItem value={i.days} key={i.label}>
          {i.label}
        </MenuItem>
      ))}
    </Select>
  );
};
